/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    // Global
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'always',
        },
    },
    // Widgets
    {
        name: 'ApplicationDetailsForm',
        import: () => import('@stories/Widgets/ApplicationDetailsForm/ApplicationDetailsForm'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    // Widgets
    {
        name: 'ApplicationForm',
        import: () => import('@stories/Widgets/ApplicationForm/ApplicationForm'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import('@stories/Widgets/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaEmbed',
        import: () => import('@stories/Widgets/MediaEmbed/MediaEmbed'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitTextMedia',
        import: () => import('@stories/Widgets/SplitTextMedia/SplitTextMedia'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AdvertisingBanner',
        import: () => import('@stories/Widgets/AdvertisingBanner/AdvertisingBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CarouselBanner',
        import: () => import('@stories/Widgets/CarouselBanner/CarouselBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CtaButton',
        import: () => import('@stories/Widgets/CtaButton/CtaButton'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Accordion',
        import: () => import('@stories/Widgets/Accordion/Accordion'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InvoicesList',
        import: () => import('@stories/Widgets/InvoicesList/InvoicesList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MarketingPreferences',
        import: () => import('@stories/Widgets/MarketingPreferences/MarketingPreferences'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'DirectoryListing',
        import: () => import('@stories/Widgets/DirectoryListing/DirectoryListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturedArticles',
        import: () => import('@stories/Widgets/FeaturedArticles/FeaturedArticles'),
        config: {
            hydrate: 'in-view',
        },
    }
];
